import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import { FocusHeader } from '@olxbr/ds-web'
import AccessNavigator, { createNewRouter } from '../AccessNavigator'
import { RevalidationPhoneCheckPinCodePage } from '../RevalidationPhoneCheckPinCodePage/RevalidationPhoneCheckPinCodePage'
import { RevalidationEmailCheckPinCodePage } from '../RevalidationEmailCheckPinCodePage/RevalidationEmailCheckPinCodePage'
import { SendPhoneRevalidationPinCodePage } from '../SendPhoneRevalidationPinCodePage'
import { SendEmailRevalidationPinCodePage } from '../SendEmailRevalidationPinCodePage'
import { RemoveRevalidationPhoneCheckPinCodePage } from '../RemoveRevalidationPhoneCheckPinCodePage'
import AccountUpdatePage from '../AccountUpdatePage'
import CountdownProvider from '../../../util/providers/CountdownProvider'
import RevalidationProvider from '../../../util/providers/RevalidationProvider'
import styled from 'styled-components'
import { breakpoints } from '../../../util/medias'

const router = createNewRouter('AccountUpdate')

const HeaderWrapper = styled.div`
  & .olx-header__icon-button {
    @media screen and (min-width: ${breakpoints['mobile'] + 1}px) {
      display: none;
    }
  }
`
export const AccountRevalidationStack = ({ onSuccess, token, afterRevalidation }) => {
  const refSendEmail = useRef(null)
  const refSendPhone = useRef(null)

  const onSendCodeSuccess = () => {
    router.push('RevalidationPhoneCheckPinCodePage')
  }

  const onSendEmailCodeSuccess = () => {
    router.push('RevalidationEmailCheckPinCodePage')
  }

  const goBackToBeginning = () => router.push('AccountUpdate')

  const goBack = e => {
    if (e) e.preventDefault()

    if (router.canPop()) {
      router.pop()
    } else {
      goBackToBeginning()
    }
  }

  const onBackRef = () => {
    if (refSendEmail.current) refSendEmail.current.handleBack()
    else if (refSendPhone.current) refSendPhone.current.handleBack()
    else goBack()
  }

  const redirectOnPhoneConflict = () => {
    router.push('RemoveRevalidationPhoneCheckPinCodePage')
  }

  const PhoneRoutes = {
    sendPhoneRevalidationPinCodeRoute: {
      route: 'SendPhoneRevalidationPinCodeRoute',
      component: () => (
        <SendPhoneRevalidationPinCodePage
          ref={refSendPhone}
          onSuccess={onSendCodeSuccess}
          onBack={goBack}
        />
      ),
    },
    checkPinCodeRoute: {
      route: 'RevalidationPhoneCheckPinCodePage',
      component: () => (
        <RevalidationPhoneCheckPinCodePage
          onBackClick={goBack}
          onSuccess={goBackToBeginning}
          redirectOnPhoneConflict={redirectOnPhoneConflict}
        />
      ),
    },
    removeRevalidationPhoneCheckPinCodePage: {
      route: 'RemoveRevalidationPhoneCheckPinCodePage',
      component: () => (
        <RemoveRevalidationPhoneCheckPinCodePage
          onBackClick={goBack}
          onSuccess={goBackToBeginning}
        />
      ),
    },
  }

  const EmailRoutes = {
    sendEmailRevalidationPinCodeRoute: {
      route: 'SendEmailRevalidationPinCode',
      component: () => (
        <SendEmailRevalidationPinCodePage
          ref={refSendEmail}
          onSuccess={onSendEmailCodeSuccess}
          onBack={goBack}
        />
      ),
    },
    checkEmailPinCodeRoute: {
      route: 'RevalidationEmailCheckPinCodePage',
      component: () => (
        <RevalidationEmailCheckPinCodePage onBackClick={goBack} onSuccess={goBackToBeginning} />
      ),
    },
  }

  return (
    <RevalidationProvider token={token}>
      <CountdownProvider>
        <HeaderWrapper>
          <FocusHeader goBack={onBackRef} />
        </HeaderWrapper>
        <div className="flex pt-3 pr-2 pl-2" style={{ backgroundColor: 'var(--color-neutral-70)' }}>
          <AccessNavigator
            router={router}
            routes={[
              {
                route: 'AccountUpdate',
                component: () => (
                  <AccountUpdatePage
                    onSuccess={onSuccess}
                    afterRevalidation={afterRevalidation}
                    onClickRevalidatePhone={() => router.push('SendPhoneRevalidationPinCodeRoute')}
                    onClickRevalidateEmail={() => router.push('SendEmailRevalidationPinCode')}
                  />
                ),
              },
              PhoneRoutes.sendPhoneRevalidationPinCodeRoute,
              PhoneRoutes.checkPinCodeRoute,
              PhoneRoutes.removeRevalidationPhoneCheckPinCodePage,
              EmailRoutes.sendEmailRevalidationPinCodeRoute,
              EmailRoutes.checkEmailPinCodeRoute,
            ]}
          />
        </div>
      </CountdownProvider>
    </RevalidationProvider>
  )
}

AccountRevalidationStack.propTypes = {
  onSuccess: PropTypes.func,
  afterRevalidation: PropTypes.func,
  token: PropTypes.string,
}
